
/**
 * @Description 小天才扫码登陆
 */
import { FC, useEffect, useState } from 'react';
import { Button } from 'antd';
import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { getQWLoginConfig } from '@/common/api/wecom';
import { redirectURI } from './ts-config';
import cs from 'classnames';
import styles from './entry.module.less';
import WeComQrcode from '@/views/wecom/pages/qrcode/entry';

interface XTCQWCodeProps {

};
const XTCQWCode: FC<XTCQWCodeProps> = () => {
  // const onRef: any = useRef();
  const [tenantList, setTenantList] = useState<any[]>([]);
  const [curConfig, setCurConfig] = useState<any>();

  useEffect(() => {
    methods.loadData();
  }, []);

  const methods = useMethods({
    loadData() {
      getQWLoginConfig().then((res: any) => {
        const data = isArray(res) ? res : [];
        setTenantList(data);
        const defaultConfig = data[0];
        if (defaultConfig?.appId) {
          const { agentId, appId, corpName } = defaultConfig;
          setCurConfig({
            agentid: agentId,
            appid: appId,
            name: corpName
          });
        }
      });
    },
  });
  return (<div className={styles.boxCon}>
    <div className={styles.container}>
      <div className={cs('ct fs-24 bold c-222', styles.titCon)}>
        统一登录
      </div>
      {/* 小天才扫码登录 */}
      <div className={styles.qwPanelCon}>
        {
          curConfig && <WeComQrcode
            panelParams={{
              ...curConfig,
              redirect_uri: redirectURI
            }}
          />
        }
      </div>
      <div className='ct'>
        {
          tenantList?.map((item: any, index: number) => <Button
            key={index}
            type={item.appId === curConfig?.appid ? 'primary' : 'default'}
            onClick={() => {
              const { agentId, appId, corpName } = item;
              setCurConfig({
                agentid: agentId,
                appid: appId,
                name: corpName
              });
            }}
            className='mr-8'
            style={{
              ...(item.appId === curConfig?.appid ? {
                background: '#FE7E11',
                borderColor: '#FE7E11'
              } : {})
            }}
          >
            {item.corpName}
          </Button>)
        }
      </div>
    </div>
  </div>
  );
};

export default XTCQWCode;
